export const companyInfo = {
  nombre: "AXONIA GROUP",
  lema: "Transporte y soluciones de movilidad para cada necesidad",
  descripcionCorta: "Transporte, logística y alquiler de unidades para empresas y particulares.",
  telefono: "+51 987 654 321",
  telefonoLink: "tel:+51987654321",
  whatsapp: "+51 987 654 321",
  whatsappLink: "https://wa.me/51987654321",
  email: "servicios@axoniagroup.com",
  emailLink: "mailto:servicios@axoniagroup.com",
  direccion: "Av. Los Transportistas 1450, Parque Industrial",
  ciudad: "Lima, Perú",
  horario: "Lunes a Sábado · 7:00 a 20:00",
  mapaEmbed:
    "https://www.google.com/maps?q=Parque+Industrial+Lima+Peru&output=embed",
  redes: [
    { nombre: "Facebook", icono: "ri-facebook-fill", url: "https://facebook.com" },
    { nombre: "Instagram", icono: "ri-instagram-line", url: "https://instagram.com" },
    { nombre: "LinkedIn", icono: "ri-linkedin-fill", url: "https://linkedin.com" },
    { nombre: "YouTube", icono: "ri-youtube-fill", url: "https://youtube.com" },
  ],
};

export const heroSlides = [
  {
    id: "hero-1",
    titulo: "Transporte y soluciones de movilidad para cada necesidad",
    subtitulo:
      "Solicita camiones, furgonetas, autobuses y unidades de transporte para mudanzas, acarreos, eventos, distribución y servicios especiales.",
    imagen_url:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20view%20of%20a%20fleet%20of%20white%20logistics%20trucks%20and%20vans%20lined%20up%20on%20a%20clean%20open%20terminal%20at%20blue%20hour%2C%20dramatic%20sky%2C%20professional%20corporate%20transport%20photography%2C%20deep%20blue%20tones%2C%20high%20detail%2C%20harmonious%20composition&width=1920&height=1080&seq=axonia-hero-01&orientation=landscape",
  },
  {
    id: "hero-2",
    titulo: "Mudanzas y acarreos con personal profesional",
    subtitulo:
      "Equipo capacitado, unidades equipadas y cobertura para que tu carga llegue segura y a tiempo.",
    imagen_url:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20scene%20of%20a%20professional%20moving%20crew%20loading%20boxes%20and%20furniture%20into%20a%20white%20truck%20outside%20a%20modern%20building%20at%20dusk%2C%20cool%20blue%20tones%2C%20corporate%20logistics%20photography%2C%20high%20detail&width=1920&height=1080&seq=axonia-hero-02&orientation=landscape",
  },
  {
    id: "hero-3",
    titulo: "Unidades para eventos, grupos y empresas",
    subtitulo:
      "Autobuses, minibuses y vehículos especiales para movilizar personas y producir eventos sin complicaciones.",
    imagen_url:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20view%20of%20a%20modern%20white%20coach%20bus%20and%20event%20van%20on%20a%20clean%20open%20road%20at%20sunset%20with%20blue%20sky%2C%20professional%20corporate%20transport%20photography%2C%20deep%20blue%20tones%2C%20high%20detail&width=1920&height=1080&seq=axonia-hero-03&orientation=landscape",
  },
];

export const stats = [
  { id: "stat-1", valor: "18+", etiqueta: "Años de experiencia", icono: "ri-award-line" },
  { id: "stat-2", valor: "120+", etiqueta: "Unidades disponibles", icono: "ri-truck-line" },
  { id: "stat-3", valor: "4.500+", etiqueta: "Servicios completados", icono: "ri-checkbox-circle-line" },
  { id: "stat-4", valor: "24/7", etiqueta: "Atención y coordinación", icono: "ri-customer-service-2-line" },
];

export const processSteps = [
  {
    id: "step-1",
    titulo: "Cuéntanos qué necesitas",
    descripcion: "Completa la solicitud con tu servicio, fecha y destinos. Si no estás seguro, pide asesoría.",
    icono: "ri-edit-box-line",
  },
  {
    id: "step-2",
    titulo: "Te asignamos la unidad",
    descripcion: "Revisamos tu caso y proponemos la unidad y el equipo más adecuados para la operación.",
    icono: "ri-route-line",
  },
  {
    id: "step-3",
    titulo: "Coordinamos la operación",
    descripcion: "Confirmamos horarios, puntos de recogida y destino, y preparamos todo para el día del servicio.",
    icono: "ri-calendar-check-line",
  },
  {
    id: "step-4",
    titulo: "Realizamos el servicio",
    descripcion: "Nuestro equipo ejecuta el transporte con seguimiento y atención hasta la entrega final.",
    icono: "ri-shield-check-line",
  },
];

export const testimonials = [
  {
    id: "test-1",
    nombre: "María Fernández",
    cargo: "Gerente de Operaciones, Distribuidora Andina",
    texto:
      "Coordinamos con AXONIA GROUP toda nuestra distribución urbana. Cumplen los horarios y el equipo siempre es muy profesional.",
    valoracion: 5,
  },
  {
    id: "test-2",
    nombre: "Carlos Rivas",
    cargo: "Productor de eventos",
    texto:
      "Nos apoyaron con el transporte de producción para un festival. Llegaron puntual y todo el equipo fue impecable.",
    valoracion: 5,
  },
  {
    id: "test-3",
    nombre: "Lucía Ortega",
    cargo: "Cliente particular",
    texto:
      "Pedí una mudanza completa y me asesoraron desde el inicio. Rápido, seguro y sin sorpresas en el costo.",
    valoracion: 5,
  },
];